import { SiProgress } from 'react-icons/si';
import {
  IconSetType,
  IconSetsValidation,
  ValidationRule,
} from '../../../../../../sheet/types';
import { UpdateRule } from '../useCreateDataValidation';
import { RiCheckboxMultipleFill } from 'react-icons/ri';
import { MdRadioButtonChecked } from 'react-icons/md';
import { useRef } from 'react';
import Picker1 from '../../../../../../core/components/pickers/Picker1';

interface IconSetTypePickerProps {
  setType: IconSetType;
  updateRule: UpdateRule;
}
const IconSetTypePicker = ({ setType, updateRule }: IconSetTypePickerProps) => {
  const selectedRef = useRef<HTMLButtonElement | null>(null);

  const options = getIconSetTypeOptions();
  const changeSetType = (iconSetType: IconSetType) => {
    updateRule({ setType: iconSetType });
  };

  const Icon = getSetTypeIcon(setType);

  const menu = (
    <Picker1.Menu ref={selectedRef}>
      <Picker1.MenuButton Icon={<Icon />} title={setType} />
      <Picker1.MenuList
        selectedRef={selectedRef}
        selectedValue={setType}
        optionsWithIcons={options}
        changeValue={changeSetType}
      />
    </Picker1.Menu>
  );

  return menu
};

// #region helpers
const getIconSetTypeOptions = () =>
  Object.values(IconSetType).map((name) => ({
    name,
    Icon: getSetTypeIcon(name),
  }));

const getSetTypeIcon = (name: IconSetType) => {
  switch (name) {
    case IconSetType.Single:
      return MdRadioButtonChecked;
    case IconSetType.Multiple:
      return RiCheckboxMultipleFill;
    case IconSetType.Progressive:
      return SiProgress;
  }
};

// #endregion

export default IconSetTypePicker;
